import { Box, Theme, Typography } from '@mui/material';

import { Link } from '@/containers';
import { LumiQCombinationMarkIcon } from '@/icons';
import { forgotPasswordBackground } from '@/images';

export const AuthPageWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Box
      sx={[
        styles.pageContainer,
        styles.centerColumn,
        styles.gradientBackground,
      ]}>
      <Box sx={[styles.pageSection, styles.centerColumn]}>
        <Box sx={styles.centerColumn}>
          <LumiQCombinationMarkIcon
            sx={{
              width: 150,
              height: 39,
              color: 'text.contrast',
              mt: 4,
              mb: 2,
            }}
          />
          <Box sx={styles.pagePasswordForm}>{children}</Box>
        </Box>
        <Box sx={[styles.centerColumn, styles.footer]}>
          <Typography variant="body2">Having issues?</Typography>
          <Link color="text.contrast" onClick={() => window.Intercom?.('show')}>
            Contact Us
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  centerColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  pageContainer: {
    minHeight: '100vh',
    width: '100%',
  },
  pageSection: {
    minHeight: '100vh',
    justifyContent: 'space-between',
    maxWidth: 640,
    width: '100%',
    py: 4,
    px: 2,
    wordBreak: 'break-word',
  },
  gradientBackground: {
    background: (theme: Theme) =>
      `url(${forgotPasswordBackground}), ${theme.palette.gradients.forgotPassword}`,
  },
  pagePasswordForm: {
    backgroundColor: 'surface.background',
    p: 4,
    borderRadius: 1,
    textAlign: 'center',
    width: '100%',
  },
  footer: {
    color: 'surface.background',
    mt: 4,
  },
};
